//
// @params
//
//

export function stringHasSpecialCharacters(string) {
  const format = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  return format.test(string);
}
//
// @params
//
//

export function fileNameHasSpecialCharacters(string) {
  const format = /[`!@#$%^&*()+\=\[\]{};':"\\|,.<>\/?~]/;
  return format.test(string);
}
